export interface ModifierColor {
  label: string;
  value: string | null;
  color: string | null;
}

export const MODIFIER_COLORS: ModifierColor[] = [
  { label: 'common.none', value: null, color: null },
  { label: 'posManager.colorTeal', value: 'teal', color: '#009688' },
  { label: 'posManager.colorGreen', value: 'green', color: '#43A047' },
  { label: 'posManager.colorPink', value: 'pink', color: '#EC407A' },
  { label: 'posManager.colorPurple', value: 'purple', color: '#5E35B1' },
  { label: 'posManager.colorBlue', value: 'blue', color: '#0057B2' }
];

export function getModifierColor(
  value: string | null
): ModifierColor | undefined {
  return MODIFIER_COLORS.find((color) => color.value === value);
}
